<template>
    <div class="n2-container">
        <div class="n2-nav-back">
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{ $t('pages.admin.user_roles.back') }}
                    </span>
                </div>
            </a>
        </div>
        <div class="n2-page-title">
            <h3>{{ $t('pages.admin.user_roles.title') }}</h3>
        </div>
        <div class="n2-container">
            <div>
                <label>{{ $t('pages.admin.user_roles.user') }}: {{ entity.name }}</label>
            </div>
            <div v-if="roles.length > 0" class="n2-roles">
                <ul>
                    <li v-for="(entity, index) in roles" v-bind:key="entity.id">
                        <label class="n2-checkbox-lable">
                            <input type="checkbox" class="n2-checkbox-input" v-model="entity.selected"
                                v-on:change="selectRole(entity, index)">
                            <span class="n2-checkbox-text">
                                {{ entity.name }}
                            </span>
                        </label>
                    </li>
                </ul>
            </div>
            <div v-else class="title-default">
                {{ $t('shared.pager.no_record') }}
            </div>
            <validation-summary v-bind:errors="model_errors"></validation-summary>

            <div class="n2-form-group">
                <div class="n2-text-right">
                    <button v-on:click="save" class="n2-button-1">
                        {{ $t('pages.admin.user_roles.save') }}
                    </button>
                </div>
            </div>


        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import { RoleService, UserService } from '../services';
import ValidationSummary from "../components/shared/validation-summary.vue";


export default {
    components: {
        ValidationSummary
    },
    props: {
    },
    data: function () {
        return {
            model_errors: {},
            id: '',
            languages: [],
            entity: {
            },
            roles: [],
        }
    },
    computed: {
        ...mapGetters('app_settings', [
            'company_id'
        ]),
        ...mapGetters('globalization', [
            'locale',
            'language'
        ]),

    },
    watch: {

    },
    created: function () {
        this.currentService = new UserService();
        this.roleService = new RoleService();
    },
    mounted: async function () {
        const { id } = this.$route.params;
        if (id) {
            this.id = id;
            await this.loadEntity(id);
        }
    },
    methods: {
        loadEntity: async function (id) {
            let userRolesRes = await this.currentService.getRoles(id);
            let userRoles = userRolesRes.data;
            let roleRes = await this.roleService.search();
            roleRes.data.forEach(c => {
                if (userRoles.some(a => a.role_id == c.id)) { c.selected = true; }
            });
            this.roles = roleRes.data;
            this.entity = await this.currentService.find(id);

        },
        selectRole: function (role, index) {

            this.$set(this.roles, index, role);
        },
        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },

        save: async function () {
            let userRoles = this.roles.filter(a=>a.selected).map(r=>{return { role_id:r.id, user_id: this.id}});
            try {
                await this.currentService.saveRoles(this.entity.id, userRoles);
                this.$router.go(-1);
            }
            catch (err) {
                if (err.response) {
                    this.model_errors = err.response.data;
                }
            }
        },

    },

}
</script>